module.exports = __webpack_public_path__ + "static/carousel-tcvm-db131f50c359b4124871e78cdba6c05d.png";